import * as React from 'react';
import * as ReactDOM from 'react-dom';
import EventList from "../components/EventList/EventList";
import EventListTabs from "../components/EventListTabs/EventListTabs";
import {createMuiTheme, ThemeProvider} from "@material-ui/core/styles";



const theme = createMuiTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#2a3e92',
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      main: '#f68920',
      // dark: will be calculated from palette.secondary.main,
      // contrastText: '#ffcc00',
    },
    // divider: '#00ff00',
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: 3,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: 0.2,
  },
});

class CreateComponent {
    public init() {
        console.log('init');
    }

    public createEventList(elm: HTMLElement, event: string, closing_date: string) {
        ReactDOM.render(
          <React.Suspense fallback={<div>Loading...</div>}>
            {<ThemeProvider theme={theme}>
              <EventList event={event} closingDate={closing_date}/>
            </ThemeProvider>}
          </React.Suspense>,
          elm
        );
    }

  public createEventListTabs(elm: HTMLElement, events: string[], closing_date: string) {
    ReactDOM.render(
      <React.Suspense fallback={<div>Loading...</div>}>
        {<ThemeProvider theme={theme}>
          <EventListTabs events={events} closingDate={closing_date}/>
        </ThemeProvider>}
      </React.Suspense>,
      elm
    );
  }

}

const reactComponent = new CreateComponent();
(window as any).reactComponent = reactComponent;

export default reactComponent;

